import React from 'react'
import { Switch } from 'antd'
import styled from 'styled-components'
import {
  ANCILLARY_REPORT_TAB_FLAG_KEY,
  LEGACY_PLAN_MANAGEMENT_FLAG_KEY,
  SHAREPOINT_PORTAL_FLAG_KEY,
} from 'components/SideNav/link-data'
import useGlobalFlag from 'hooks/useGlobalFlag'
import useUpsertGlobalFlag from 'hooks/useUpsertGlobalFlag'

const Section = styled.div`
  margin-bottom: 32px;
`

const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
`

const SettingRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 12px 0;
`

const SettingInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const SettingLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
`

const SettingDescription = styled.div`
  font-size: 13px;
  color: #6b7280;
  max-width: 480px;
`

function GlobalFlagRow({
  flagKey,
  label,
  description,
}: {
  flagKey: string
  label: string
  description: string
}) {
  const { isEnabled, isLoading } = useGlobalFlag(flagKey)
  const upsertGlobalFlag = useUpsertGlobalFlag()

  return (
    <SettingRow>
      <SettingInfo>
        <SettingLabel>{label}</SettingLabel>
        <SettingDescription>{description}</SettingDescription>
      </SettingInfo>
      <Switch
        checked={isEnabled}
        loading={isLoading || upsertGlobalFlag.isPending}
        onChange={(value: boolean) =>
          upsertGlobalFlag.mutate({ key: flagKey, value })
        }
        aria-label={label}
      />
    </SettingRow>
  )
}

export default function FeatureFlagSettings() {
  return (
    <div style={{ maxWidth: 640, padding: '24px 0' }}>
      <Section>
        <SectionTitle>Plan Management</SectionTitle>
        <GlobalFlagRow
          flagKey={LEGACY_PLAN_MANAGEMENT_FLAG_KEY}
          label="Enable Legacy Plan Management"
          description='Shows the legacy "Health Plan" and "Plan Management" sidebar tabs.'
        />
      </Section>
      <Section>
        <SectionTitle>Reports</SectionTitle>
        <GlobalFlagRow
          flagKey={ANCILLARY_REPORT_TAB_FLAG_KEY}
          label="Show Ancillary Dashboard Tab"
          description="Shows the Ancillary Dashboard tab in the sidebar for platform admins. When off, the page still opens from its URL."
        />
      </Section>
      <Section>
        <SectionTitle>SharePoint</SectionTitle>
        <GlobalFlagRow
          flagKey={SHAREPOINT_PORTAL_FLAG_KEY}
          label="Enable SharePoint Portal"
          description="Shows the SharePoint Portal tab in the sidebar and opens the /sharepoint page for platform admins. When off, both are hidden."
        />
      </Section>
    </div>
  )
}
